// extracted by mini-css-extract-plugin
export default {"center":"ActionColumn_center__Q5NY2","actionButton":"ActionColumn_actionButton__Yamvw"};